<div class="overlay" *ngIf="showPopup" (click)="closePopup()">
  <div
    class="formula-popup"
    [class.formula-popup--historical]="historicalOffer && step === 'plans'"
    (click)="$event.stopPropagation()"
  >
    <div class="header">
      <img class="logo" src="assets/img/brand/logo.png" alt="logo-eva" />
      <button type="button" class="close-btn" (click)="closePopup()">
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
          stroke-linecap="round"
        >
          <path d="M5 5l14 14M19 5L5 19"></path>
        </svg>
      </button>
    </div>

    <div class="content">
      <ng-container *ngIf="step === 'plans'">
        <div class="overage-banner" *ngIf="evaSubscription?.formula_overage_blocked">
          Vous avez dépassé le forfait gratuit EVA Pro (100'000 CHF facturés). Choisissez une formule pour continuer à
          créer des factures clients.
        </div>

        <div class="plans-grid" [class.plans-grid--historical]="historicalOffer" *ngIf="proFormula && ecoFormula">
          @if (historicalOffer; as offer) {
            <div class="plan-card historical">
              <div class="plan-label">VOTRE ABONNEMENT ACTUEL</div>
              <div class="plan-name-row">
                <span class="plan-name">{{ offer.name }}</span>
              </div>
              <div class="plan-tagline">{{ offer.is_legacy ? "Offre historique" : "Vos conditions actuelles" }}</div>

              @if (offer.amount !== null) {
                <div class="price-row">
                  <span class="price-value">{{ offer.amount | number: "1.0-2" }} {{ offer.currency }}</span>
                </div>
                <div class="price-caption">{{ historicalPriceSuffix }}</div>
              } @else {
                <div class="price-row"><span class="price-value">Tarif personnalisé</span></div>
                <div class="price-caption">Selon votre contrat</div>
              }

              @if (historicalFuturePrice; as futurePrice) {
                <div class="historical-future-price">
                  <div class="historical-future-date">À partir du 01.01.2027</div>
                  <div class="historical-future-amount">
                    {{ futurePrice.amount | number: "1.0-2" }} {{ offer.currency }}
                    <span class="historical-future-suffix">{{ historicalPriceSuffix }}</span>
                  </div>
                  @if (futurePrice.amount < futurePrice.standardAmount) {
                    <div class="historical-future-comparison">
                      au lieu de {{ futurePrice.standardAmount | number: "1.0-2" }} {{ offer.currency }}
                    </div>
                  }
                </div>
              }

              <div class="features-list">
                <div class="feature-row">
                  @if (offer.employee_limit !== null) {
                    <span>{{ offer.employee_limit }} utilisateur{{ offer.employee_limit > 1 ? "s" : "" }} inclus</span>
                  } @else {
                    <span>Utilisateurs selon votre contrat</span>
                  }
                </div>
                @if (offer.accountant_limit !== null) {
                  <div class="feature-row">
                    <span
                      >{{ offer.accountant_limit }} accès fiduciaire{{ offer.accountant_limit > 1 ? "s" : "" }}</span
                    >
                  </div>
                }
              </div>
              <p class="historical-note">Les accès indiqués correspondent à votre abonnement actuel.</p>
              <div class="plan-actions">
                <eva-button label="Formule actuelle" [disabled]="true" [block]="true" />
                <eva-button
                  [label]="evaSubscription?.stripe_subscription_id ? 'Gérer mon abonnement' : 'Contacter EVA'"
                  variant="outlined"
                  [block]="true"
                  [loading]="openingPortal"
                  (onClick)="manageSubscription()"
                />
              </div>
            </div>
          }
          <!-- EVA Pro -->
          <div class="plan-card pro">
            <div class="plan-label">FORMULE</div>
            <div class="plan-name-row">
              <span class="plan-name">EVA Pro</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3b8ff5" stroke-width="2">
                <rect x="3" y="7" width="18" height="13" rx="2"></rect>
                <path d="M9 7V5h6v2M3 13h18"></path>
              </svg>
            </div>
            <div class="plan-tagline">Pour démarrer</div>

            <div class="price-row">
              <span class="price-value">{{
                historicalOffer ? proFormula.monthlyPrices.CHF + " CHF" : proFormula.priceHeadline
              }}</span>
              <span class="price-suffix" *ngIf="proFormula.priceHeadlineSuffix">{{
                historicalOffer ? "HT / mois" : proFormula.priceHeadlineSuffix
              }}</span>
            </div>
            <div class="price-caption" *ngIf="proFormula.priceCaption && !historicalOffer">
              {{ proFormula.priceCaption }}
            </div>

            <ng-container *ngIf="!proOpen">
              <div class="features-list">
                <div class="feature-row" *ngFor="let feature of proFormula.summaryFeatures">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#3b8ff5" class="feature-icon">
                    <rect width="24" height="24" rx="4"></rect>
                    <path
                      d="M6.5 12.4l3.4 3.4 7.5-7.6"
                      fill="none"
                      stroke="#fff"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    ></path>
                  </svg>
                  <span class="feature-text">{{ feature }}</span>
                </div>
              </div>
              <button
                type="button"
                class="details-toggle"
                *ngIf="proFormula.detailedFeatures?.length"
                (click)="toggleProDetails()"
              >
                + de détails sur les fonctionnalités
              </button>
            </ng-container>

            <ng-container *ngIf="proOpen">
              <button type="button" class="details-toggle" (click)="toggleProDetails()">
                − de détails sur les fonctionnalités
              </button>
              <div class="features-list features-list--detailed">
                <div class="feature-row feature-row--multiline" *ngFor="let feat of proFormula.detailedFeatures">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#3b8ff5" class="feature-icon">
                    <rect width="24" height="24" rx="4"></rect>
                    <path
                      d="M6.5 12.4l3.4 3.4 7.5-7.6"
                      fill="none"
                      stroke="#fff"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    ></path>
                  </svg>
                  <span class="feature-text feature-text--detailed">{{ feat }}</span>
                </div>
              </div>
            </ng-container>

            <div class="plan-actions">
              <button
                type="button"
                class="btn-primary"
                *ngIf="!proFormula.active"
                (click)="goToPaymentStep(Formulas.EVA_PRO)"
              >
                {{ historicalOffer ? "Passer à EVA Pro" : "Souscrire" }}
              </button>
              <button type="button" class="btn-primary" disabled *ngIf="proFormula.active">Formule actuelle</button>
              @if (
                proFormula.active && evaSubscription?.status === "ACTIVE" && evaSubscription?.stripe_subscription_id
              ) {
                <eva-button
                  label="Gérer ma formule"
                  variant="outlined"
                  [block]="true"
                  [loading]="openingPortal"
                  (onClick)="manageSubscription()"
                />
              } @else {
                <button type="button" class="btn-outline" (click)="demoEva()">Demander une démo</button>
              }
            </div>
          </div>

          <!-- EVA 360 -->
          <div class="plan-card eco">
            <div class="plan-ribbon">Formule conseillée</div>

            <div class="plan-label">FORMULE</div>
            <div class="plan-name-row">
              <span class="plan-name">EVA 360</span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#CDD457"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M8.2 14.4L6.4 21l5.6-3 5.6 3-1.8-6.6"></path>
                <circle cx="12" cy="9" r="5.6"></circle>
                <path
                  d="M12 6.4l1.1 2.2 2.4.3-1.8 1.7.5 2.4-2.2-1.2-2.2 1.2.5-2.4-1.8-1.7 2.4-.3z"
                  fill="#CDD457"
                  stroke="none"
                ></path>
              </svg>
            </div>
            <div class="plan-tagline">Tout l'écosystème EVA-IT</div>

            <div class="price-label" *ngIf="ecoFormula.priceLabel">{{ ecoFormula.priceLabel }}</div>
            <div class="price-row price-row--eco">
              <span class="price-value">{{ ecoFormula.priceHeadline }}</span>
              <span class="price-suffix" *ngIf="ecoFormula.priceHeadlineSuffix">{{
                ecoFormula.priceHeadlineSuffix
              }}</span>
            </div>

            <ng-container *ngIf="!ecoOpen">
              <div class="features-list">
                <div class="feature-row" *ngFor="let feature of ecoFormula.summaryFeatures">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#CDD457" class="feature-icon">
                    <rect width="24" height="24" rx="4"></rect>
                    <path
                      d="M6.5 12.4l3.4 3.4 7.5-7.6"
                      fill="none"
                      stroke="#101a4a"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    ></path>
                  </svg>
                  <span class="feature-text feature-text--eco">{{ feature }}</span>
                </div>
              </div>

              <button
                type="button"
                class="details-toggle details-toggle--eco"
                *ngIf="ecoFormula.detailedFeatures?.length"
                (click)="toggleEcoDetails()"
              >
                + de détails sur les fonctionnalités
              </button>

              <div class="option-block" *ngIf="ecoFormula.optionalFeatures?.length">
                <div class="option-title">En option</div>
                <div class="features-list">
                  <div class="feature-row feature-row--multiline" *ngFor="let opt of ecoFormula.optionalFeatures">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#6f4fd8" class="feature-icon">
                      <rect width="24" height="24" rx="4"></rect>
                      <path
                        d="M6.5 12.4l3.4 3.4 7.5-7.6"
                        fill="none"
                        stroke="#c9bdf2"
                        stroke-width="2.4"
                        stroke-linecap="round"
                      ></path>
                    </svg>
                    <span class="feature-text feature-text--eco">{{ opt }}</span>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="ecoOpen">
              <button type="button" class="details-toggle details-toggle--eco" (click)="toggleEcoDetails()">
                − de détails sur les fonctionnalités
              </button>
              <div class="features-list features-list--detailed">
                <div class="feature-row feature-row--multiline" *ngFor="let feat of ecoFormula.detailedFeatures">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="#CDD457" class="feature-icon">
                    <rect width="24" height="24" rx="4"></rect>
                    <path
                      d="M6.5 12.4l3.4 3.4 7.5-7.6"
                      fill="none"
                      stroke="#101a4a"
                      stroke-width="2.4"
                      stroke-linecap="round"
                    ></path>
                  </svg>
                  <span class="feature-text feature-text--eco">{{ feat }}</span>
                </div>
              </div>
            </ng-container>

            <div class="plan-actions">
              <button
                type="button"
                class="btn-primary btn-primary--eco"
                *ngIf="!ecoFormula.active"
                (click)="goToPaymentStep(Formulas.EVA_360)"
              >
                Souscrire
              </button>
              <button type="button" class="btn-primary btn-primary--eco" disabled *ngIf="ecoFormula.active">
                Formule actuelle
              </button>
              <button type="button" class="btn-outline btn-outline--eco" (click)="demoEva()">Demander une démo</button>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="payment-step" *ngIf="step === 'pay'">
        <button type="button" class="back-link" (click)="backToPlans()">‹ Retour aux formules</button>

        <div class="payment-title">Mode de paiement</div>
        <div class="payment-subtitle">
          Formule sélectionnée : <strong>{{ chosenFormulaObject?.name }}</strong>
        </div>

        <div class="payment-methods">
          <button
            type="button"
            class="payment-method"
            [class.selected]="paymentMethod === 'invoice'"
            (click)="pickPaymentMethod('invoice')"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0d2083" stroke-width="1.8">
              <path d="M6 3h9l3.5 3.5V21H6z"></path>
              <path d="M9 10h7M9 14h7M9 18h4"></path>
            </svg>
            <span class="payment-method-text">
              <span class="payment-method-title-row">
                <span class="payment-method-title">Paiement sur facture</span>
                <span class="payment-method-badge">Recommandé</span>
              </span>
              <span class="payment-method-desc">Facture QR à 30 jours, envoyée par e-mail</span>
            </span>
          </button>

          <button
            type="button"
            class="payment-method"
            *ngIf="canPayByCard"
            [class.selected]="paymentMethod === 'card'"
            (click)="pickPaymentMethod('card')"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#0d2083" stroke-width="1.8">
              <rect x="2.5" y="5" width="19" height="14" rx="2.5"></rect>
              <path d="M2.5 10h19M6 15h4"></path>
            </svg>
            <span class="payment-method-text">
              <span class="payment-method-title">Carte bancaire</span>
              <span class="payment-method-desc">Paiement sécurisé via Stripe — accès immédiat</span>
            </span>
          </button>
        </div>

        <div class="payment-custom-note" *ngIf="!canPayByCard">
          @if (historicalOffer && chosenFormula === Formulas.EVA_PRO) {
            Notre équipe vous accompagne pour modifier votre contrat actuel et passer à EVA Pro.
          } @else {
            EVA 360 est une formule sur-mesure : notre équipe vous enverra une facture adaptée à votre configuration.
          }
        </div>

        <button type="button" class="btn-primary payment-confirm" (click)="confirmPayment()">
          {{ paymentMethod === "card" ? "Continuer vers le paiement" : "Recevoir la facture" }}
        </button>

        <div class="payment-footnote">Vos données sont conservées quelle que soit l'option choisie.</div>
      </div>

      <div class="success-step" *ngIf="step === 'success'">
        <div class="success-badge"><ng-icon name="heroCheck"></ng-icon></div>
        <div class="success-title">Demande envoyée</div>
        <div class="success-subtitle">
          Merci, notre équipe a bien reçu votre demande pour la formule {{ chosenFormulaObject?.name }} et vous fera
          parvenir votre facture par e-mail.
        </div>
        <button type="button" class="btn-outline success-close" (click)="closePopup()">Fermer</button>
      </div>

      <a class="whatsapp-contact" [href]="whatsappLink" target="_blank" rel="noopener" *ngIf="step !== 'success'">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="#25D366">
          <path d="M12 2.5A9.5 9.5 0 0 0 3.8 16.8L2.5 21.5l4.8-1.3A9.5 9.5 0 1 0 12 2.5z"></path>
          <path
            d="M8.6 7.6c.3-.1.7 0 .9.4l.7 1.3c.2.3.1.6-.1.8l-.5.5c-.2.2-.2.4-.1.6.4.8 1.4 1.8 2.2 2.2.2.1.4.1.6-.1l.5-.5c.2-.2.5-.3.8-.1l1.3.7c.4.2.5.6.4.9-.3.9-1.3 1.4-2.2 1.2-2.6-.5-5-2.9-5.5-5.5-.2-.9.3-1.9 1-2.4z"
            fill="#fff"
          ></path>
        </svg>
        <span>Contactez directement notre expert EVA IT — <strong>078 318 90 46</strong></span>
      </a>
    </div>

    <div class="header-pink">
      <div class="item">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 3l7 3v6c0 4.2-2.9 7.7-7 9-4.1-1.3-7-4.8-7-9V6l7-3z"></path>
          <path d="M9 12l2.2 2.2L15.5 10"></path>
        </svg>
        <span>Données sécurisées en Suisse</span>
      </div>
      <div class="item">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 5h16v11H9l-5 4V5z"></path>
        </svg>
        <span>Support humain gratuit</span>
      </div>
      <div class="item">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="4" y="4" width="16" height="16" rx="3"></rect>
          <path d="M12 8v8M8 12h8"></path>
        </svg>
        <span>Swiss made software</span>
      </div>
    </div>
  </div>
</div>
